import React from 'react'

import gsap from 'gsap'
import { useGSAP } from '@gsap/react'

import './styles/header.css'


const Header = () => {

  gsap.registerPlugin(useGSAP)

  useGSAP(() => {
    gsap.fromTo('.header',
      { x: '-100px', opacity: 0, }, {
        x: '10px', opacity: 1,
        duration: 0.25,
        ease: 'easeIn',
      })
  })

  return (
    <React.Fragment>
      <h1 className="header">
        <a href="/">psych.cat</a>
      </h1>
    </React.Fragment>
  )
}


export default Header
